import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './ErrorModal.styled';
import { Modal } from '@/components/UI/Modal';
import { Button } from '@/components/UI/Button/Button';

interface ErrorModalProps {
  isOpen: boolean;
  message?: string;
  onClose: () => void;
}

export const ErrorModal = ({
  isOpen,
  onClose,
  message = '',
}: ErrorModalProps) => {
  const { t } = useTranslation();
  const safeMessage = message || t('bookmark_collections.common_error_message');

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <S.ErrorModal>
        <S.Title>{t('bookmark_collections.common_error_title')}</S.Title>
        <S.Message>{safeMessage}</S.Message>
        <Button
          isFullWidth
          appearance="secondary"
          borderRadius={14}
          onClick={onClose}
        >
          {t('bookmark_collections.okay_button')}
        </Button>
      </S.ErrorModal>
    </Modal>
  );
};
